/**
 * Created by wuhao on 2016/12/7.
 */
import apiObj from '@/api/index';
import config from '@/config';
import {getToken} from '@/utils/auth';
import {Global} from 'aegis-api-proxy';
import axios from 'axios';

axios.defaults.baseURL = config.basePath;
axios.interceptors.request.use(config => {
  const token = getToken();
  if (token) {
    config.headers['Authorization'] = token;
  }
  return config;
});
const apiProxy = Global.proxyAPI(apiObj, config, {
  headers: {
    common: {}
  }
});

export const api = apiProxy;
